import produce from "immer";
import actionTypes from "../actionTypes/tab";

const initialState = {
  active: "description",
};

export default function editor(state = initialState, { payload, type }) {
  const nextState = produce(state, (draft) => {
    switch (type) {
      case actionTypes.CHANGE_TAB: {
        draft.active = payload;
        break;
      }
      default:
    }
  });

  return nextState;
}
